module.exports = __webpack_public_path__ + "static/media/reply.0e49140f.svg";